<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" color="blue-grey">
                <v-icon>mdi-stairs</v-icon>
            </v-btn>
        </template>
            <v-card flat>
               <v-data-table
                    dark
                    :headers="headers"
                    :items="items"
                    class="elevation-1"
                    :items-per-page="20"
                    hide-default-footer
                    :mobile-breakpoint="300"
                ></v-data-table>
            </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'RatingChart',
    data: () => ({
        dialog: false,
        headers: [
          {
            text: '부수',
            align: 'left',
            sortable: false,
            value: 'name',
          },
          { text: '기준점수', value: 'points' },
          { text: '점수폭', value: 'pointSpread' }
        ],
        items: [
          {
            name: '선수부',
            points: 1900,
            pointSpread: 0,
          },
          {
            name: '1부+',
            points: 1870,
            pointSpread: 30,
          },
          {
            name: '1부',
            points: 1840,
            pointSpread: 30,
          },
          {
            name: '2부+',
            points: 1810,
            pointSpread: 30,
          },
          {
            name: '2부',
            points: 1780,
            pointSpread: 30,
          },
          {
            name: '3부+',
            points: 1750,
            pointSpread: 30,
          },
          {
            name: '3부',
            points: 1720,
            pointSpread: 30,
          },
          {
            name: '4부+',
            points: 1690,
            pointSpread: 30,
          },
          {
            name: '4부',
            points: 1640,
            pointSpread: 50,
          },
          {
            name: '5부+',
            points: 1580,
            pointSpread: 60,
          },
          {
            name: '5부',
            points: 1500,
            pointSpread: 80,
          },
          {
            name: '6부+',
            points: 1400,
            pointSpread: 100,
          },
          {
            name: '6부',
            points: 1300,
            pointSpread: 100,
          },
          {
            name: '7부+',
            points: 1200,
            pointSpread: 100,
          },
          {
            name: '7부',
            points: 1100,
            pointSpread: 100,
          },
          {
            name: '8부+',
            points: 1000,
            pointSpread: 100,
          },
          {
            name: '8부',
            points: 900,
            pointSpread: 100,
          },
          {
            name: '9부+',
            points: 800,
            pointSpread: 100,
          },
          {
            name: '9부',
            points: 700,
            pointSpread: 100,
          },
          
        ]
    }),
    methods: {
        
    }
}
</script>

<style>

</style>